import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PSelectItem } from '../../../../../shared/design-system/atoms/p-select/p-select-item.model';
import { Report } from '../../../../models/report.model';

@Component({
  selector: 'app-immeuble-form',
  templateUrl: './immeuble-form.component.html',
  styleUrls: ['./immeuble-form.component.scss'],
})
export class ImmeubleFormComponent implements OnChanges {
  @Input() immeuble!: Report.Characteristics.Immeuble | undefined;
  @Input() constructionYear!: number;

  @Output() immeubleChanged =
    new EventEmitter<Report.Characteristics.Immeuble>();

  @Output() constructionYearChanged = new EventEmitter<number>();

  immeubleForm = new FormGroup({
    propertyType: new FormControl('Immeuble', { nonNullable: true }),
    constructionYear: new FormControl('', [
      Validators.min(1000),
      Validators.max(9999),
      Validators.pattern(/^\d{4}$/),
    ]),
    numberOfUnits: new FormControl(''),
    profitability: new FormControl(''),
    totalAreaM2: new FormControl(''),
    premisesUsage: new FormControl(''),
  });

  hasElevatorItem!: PSelectItem;
  hasCondominiumItem!: PSelectItem;

  yesNoSelectItems: PSelectItem[] = [
    { value: 'yes', label: 'Oui' },
    { value: 'no', label: 'Non' },
  ];

  immeubleInternal!: Report.Characteristics.Immeuble;
  constructionYearinternal!: number;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['immeuble'] && changes['immeuble'].currentValue) {
      this.immeubleInternal = changes['immeuble'].currentValue;
    }

    if (
      changes['constructionYear'] &&
      changes['constructionYear'].currentValue
    ) {
      this.immeubleForm.controls.constructionYear.setValue(
        this.constructionYear.toString(),
      );
    }

    this.setFormValues();
  }

  onConstructionYearChanged(event: Event) {
    this.constructionYearinternal = parseInt(
      (event.target as HTMLInputElement).value,
    );

    this.constructionYearChanged.emit(this.constructionYearinternal);
  }

  onNumberOfUnitsChanged(event: Event) {
    this.immeubleInternal = {
      ...this.immeubleInternal,
      numberOfUnits: parseInt((event.target as HTMLInputElement).value),
    };

    this.immeubleChanged.emit(this.immeubleInternal);
  }

  onProfitabilityChanged(event: Event) {
    this.immeubleInternal = {
      ...this.immeubleInternal,
      profitability: parseInt((event.target as HTMLInputElement).value),
    };

    this.immeubleChanged.emit(this.immeubleInternal);
  }

  onTotalAreaM2Changed(event: Event) {
    this.immeubleInternal = {
      ...this.immeubleInternal,
      totalAreaM2: parseInt((event.target as HTMLInputElement).value),
    };

    this.immeubleChanged.emit(this.immeubleInternal);
  }

  onPremisesUsageChanged(event: Event) {
    this.immeubleInternal = {
      ...this.immeubleInternal,
      premisesUsage: (event.target as HTMLInputElement).value,
    };

    this.immeubleChanged.emit(this.immeubleInternal);
  }

  onHasElevatorSelected({ value }: PSelectItem): void {
    this.immeubleInternal = {
      ...this.immeubleInternal,
      hasElevator: value === 'yes',
    };

    this.hasElevatorItem = { value };

    this.immeubleChanged.emit(this.immeubleInternal);
  }

  onHasCondominiumSelected({ value }: PSelectItem): void {
    this.immeubleInternal = {
      ...this.immeubleInternal,
      hasCondominium: value === 'yes',
    };

    this.hasCondominiumItem = { value };

    this.immeubleChanged.emit(this.immeubleInternal);
  }

  setFormValues(): void {
    this.immeubleForm.controls.constructionYear.setValue(
      this.constructionYearinternal
        ? this.constructionYearinternal.toString()
        : '',
    );

    this.immeubleForm.controls.numberOfUnits.setValue(
      this.immeubleInternal?.numberOfUnits?.toString() || '',
    );

    this.immeubleForm.controls.profitability.setValue(
      this.immeubleInternal?.profitability?.toString() || '',
    );

    this.immeubleForm.controls.totalAreaM2.setValue(
      this.immeubleInternal?.totalAreaM2?.toString() || '',
    );

    this.immeubleForm.controls.premisesUsage.setValue(
      this.immeubleInternal?.premisesUsage || '',
    );

    this.hasElevatorItem = {
      value: this.immeubleInternal?.hasElevator ? 'yes' : 'no',
    };

    if (!this.immeubleInternal.hasElevator) {
      this.immeubleInternal.hasElevator = false;
    }

    if (!this.immeubleInternal.hasCondominium) {
      this.immeubleInternal.hasCondominium = false;
    }

    this.hasElevatorItem = this.immeubleInternal?.hasElevator
      ? this.yesNoSelectItems[0]
      : this.yesNoSelectItems[1];

    this.hasCondominiumItem = this.immeubleInternal?.hasCondominium
      ? this.yesNoSelectItems[0]
      : this.yesNoSelectItems[1];
  }
}
